/**
 * @generated SignedSource<<3aa81804f841f5d66b08401ac40f827e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type PricingGuidancePriceRange = "HIGHER_RANGE" | "LOWER_RANGE" | "MEDIAN" | "NEAR_MEDIAN_HIGH" | "NEAR_MEDIAN_LOW" | "OUT_OF_RANGE_HIGH" | "OUT_OF_RANGE_LOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type pricingGuidanceHelpers_item$data = {
  readonly displayPrice: ReadonlyArray<{
    readonly convertedAmountList: ReadonlyArray<{
      readonly amount: number | null;
      readonly currency: Currency | null;
    } | null> | null;
  } | null> | null;
  readonly pricingGuidance: {
    readonly price: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
    readonly priceRange: PricingGuidancePriceRange | null;
    readonly pricingGuidanceType: string | null;
  } | null;
  readonly " $fragmentType": "pricingGuidanceHelpers_item";
};
export type pricingGuidanceHelpers_item$key = {
  readonly " $data"?: pricingGuidanceHelpers_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "pricingGuidanceHelpers_item"
};

(node as any).hash = "d67f889e2eb7e8451468c305cf56e238";

export default node;
